<mat-form-field class="w-100" appearance="fill">
  <mat-label>{{label}}</mat-label>
  <input #innerAutocompleteInput matInput type="text" autocomplete="off" [value]="displayedValue$ | async"
    [matAutocomplete]="auto" (keyup)="search$$.next($any($event).target?.value)" (blur)="onTouched()">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="autoCompleteDisplayWithFn" (optionSelected)="select($event)">
    <mat-option *ngFor="let o of options$ | async" [value]="o.value">{{o.label}}
    </mat-option>
  </mat-autocomplete>
  <a matSuffix (click)=" clear(); innerAutocompleteInput.value=''"
    [hidden]=" !innerAutocompleteInput.value && !selectedValue">
    <mat-icon>clear</mat-icon>
  </a>
</mat-form-field>
